const getTextRegEx = (inputMinLength, inputMaxLength, allowableCharType = "digit") => {
  return allowableCharType === "digit" ? `^\\d{${inputMaxLength}}$` : `^.{${inputMaxLength}}$`;
};

export default getTextRegEx;
